import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink, Router } from '@angular/router';

@Component({
  selector: 'app-tab-account',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink
  ],
  templateUrl: './tab-account.component.html',
  styleUrl: './tab-account.component.scss'
})
export class TabAccountComponent {
    constructor(private router: Router){}
    current:string = ''

    ngOnInit(): void {
      this.current = this.router.url

    }
}
